import React, { useEffect, useState } from 'react'
import dashboardimg from './images/dashboardimg.png';
import selecteddashboardimg from './images/selecteddashboardimg.png';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RepeatIcon from '@mui/icons-material/Repeat';
import PerformanceDashboard from './PerformanceDashboardOperations';
import CustomerServiceDahsboard from './dashbaordCustomerService';
import RepeatDashboard from './repeatDashboard';
import Repeat from './creditRepeatDashboard';
import { ROLE } from '../../../../../utils/Constant';
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
import './performanceDashboard.scss';
import TeamPerformanceMAin from './TeamsData/Main'
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDFIN_LIKE } from '../../../../../layouts/MainTenantconfig';


export default function configMain({ admin, pageViewHandler }) {
    const [tab, setselectedtab] = useState('');

    const tabchange = (type) => {
        setselectedtab(type);

    }
    useEffect(() => {

        admin.rolelist.indexOf(ROLE.LM_Legal_Dashboard) >= 0 ?
            setselectedtab('operation') : ""

        admin.rolelist.indexOf(ROLE.LM_Customer_Service_Dashboard) >= 0 ?
            setselectedtab('customerservice') : ""

        admin.rolelist.indexOf(ROLE.LM_Credit_Dashboard) >= 0 ?
            setselectedtab('creditrepeat') : ""




    }, [])
    return (
        <>
            <div className="overallPerformanceTracker">
                <div className="PerformanceTracker">
                    <div className="container-fluid details-new fixed-top"  >
                        <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                            <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                                <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                            </div>

                            <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                                <div className="btn-group-new-performance-custom">
{ 
      (CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE)) ?
    <button className={(tab === 'teamMain') ? "active" : ""} onClick={(e) => tabchange('teamMain')}><EngineeringIcon style={{ width: '27px', height: '27px' }} /><br />Team</button>
 :""} 

                                    {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                        admin.rolelist.indexOf(ROLE.LM_Legal_Dashboard) >= 0 ?
                                            <button className={(tab === 'operation') ? "active" : ""} onClick={(e) => tabchange('operation')}><EngineeringIcon style={{ width: '27px', height: '27px' }} /><br />Operation Team</button>
                                            : "" : ""}
                                    {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                        admin.rolelist.indexOf(ROLE.LM_Customer_Service_Dashboard) >= 0 ?
                                            <button className={(tab === 'customerservice') ? "active" : ""} onClick={(e) => tabchange('customerservice')}><SupportAgentIcon style={{ width: '27px', height: '27px' }} /><br />Customer Service</button>
                                            : "" : ""}
                                    {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                        admin.rolelist.indexOf(ROLE.LM_Credit_Dashboard) >= 0 ? <button className={(tab === 'creditfresh') ? "active" : ""} onClick={(e) => tabchange('creditfresh')}><PersonAddIcon style={{ width: '27px', height: '27px' }} /><br />Credit Team <br /> (Fresh)</button>
                                            : "" : ""}
                                    {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                        admin.rolelist.indexOf(ROLE.LM_Credit_Dashboard) >= 0 ?
                                            <button className={(tab === 'creditrepeat') ? "active" : ""} onClick={(e) => tabchange('creditrepeat')}><RepeatIcon style={{ width: '27px', height: '27px' }} /><br />Credit Team <br /> (Repeat)</button>
                                            : "" : ""}
                                </div>

                            </div>
                        </div>
                    </div>
                    {tab === 'operation' ?
                        <PerformanceDashboard />
                        : ""}
                    {tab === 'customerservice' ?

                        <CustomerServiceDahsboard />
                        : ""}
                    {tab === 'creditfresh' ?
                        <RepeatDashboard />
                        : ""}
                    {tab === 'creditrepeat' ?
                        <Repeat />
                        : ""}
                    {tab === 'teamMain' ?
                        <TeamPerformanceMAin />
                        : ""}
                </div >
            </div>
        </>
    )
}
